import React from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import GroupByDropdown from "../../group-by-dropdown/GroupByDropdown";
import SortButton from "../../sort-button/sort-button";
import FilterButton from "../../filter-button/filter-button";
import {
    PriorityDropdownToggle,
    MembersDropdownToggle,
} from "../../../components/custom-project-filter-dropdowns/custom-project-filter-dropdown-toggle/custom-project-filter-dropdown-toggle";
import {
    PriorityDropdownItem,
    MemberDropdownItem,
} from "../../../components/custom-project-filter-dropdowns/custom-project-filter-dropdown-item/custom-project-filter-dropdown-item";
import { Refresh } from "../../../assets/icons";
import { FluentButton } from "../../FluentUI/Fluent-Button";
import FluentUiIcon from "../../../assets/fluent-ui-icon";

const ExpandableFilterRowNew = ({
    groupBy,
    getDataGrouped,
    dateFormatID,
    // Deal w these 3 props later
    nameDropdownData,
    memberDropdownData,
    tagDropdownData,
    updateDataFilterOptionsTotal,
    updateAppliedDataFilters,
    updateDataFilterConjunctionSelection,
    setDataSortSelection,
    setDataSortOrder,
    disabled,
    clearDataSort,
    itemFilterData,
    itemFilterData:{totalFilterOptions},
    dataSort,
    showGroupBy,
    setShowGroupBy,
    clearDataFilters,
    refreshTable,
    handleCreateBtnClick,
    totalSortOptions,
    sortHeaderText,
    children,
    pageIdentifier,
    privileges,
    labels
}) => {
        // Used for custom styling in the filter, these dropdowns have icons beside them that make styling difficult
        const selectCustomDropdownToggle = (dropdownType, selectedData) => {
            switch(dropdownType){
                case 'Priority':
                    return PriorityDropdownToggle(selectedData);
                case 'Member':
                    return MembersDropdownToggle(selectedData);
                default:
                    return null;
            }
        }

        // Used for custom styling, these dropdowns have icons beside them that make styling difficult
        const selectCustomDropdownItem = (dropdownType) => {
            switch(dropdownType){
                case 'Priority':
                    return PriorityDropdownItem;
                case 'Member':
                    return MemberDropdownItem;
                default:
                    return null;
            }
        }

        const setFilterTitle = () => {
            switch (pageIdentifier) {
                case 'project':
                    return `Filter ${labels?.ProjectPlural ?? "Projects"}`;
                case 'task':
                    return `Filter ${labels?.TaskPlural ?? "Tasks"}`;
                default:
                    return;
            }
        }

        const renderCreateBtn = () => {
            switch (pageIdentifier) {

                // Create Project button
                case "project":
                    return (disabled ?
                        <OverlayTrigger
                            placement="bottom-end"
                            overlay={
                                <Tooltip>
                                        You don't have access to create {labels?.ProjectPlural ?? "projects"}. Please contact administration for assistance.
                                </Tooltip>
                            }
                        >
                            <div className="ml-2">
                                <FluentButton
                                    style={{pointerEvents:"none"}}
                                        icon={<FluentUiIcon name={"FolderAddRegular"} color={"#fff"} size={20} />}
                                        appearance="primary"                                        
                                        text={` Create ${labels?.ProjectSingular ?? "Project"}`}
                                        disabled={disabled}
                                      />
                            </div>
                        </OverlayTrigger>
                    :
                        <React.Fragment>
                            <NavLink className=" ml-2"
                                to={{
                                    pathname: "/projects/create",
                                    state: {
                                        taskID: -1,
                                        fromCreateStd: false
                                    }
                            }}>                                
                                <FluentButton
                                        icon={<FluentUiIcon name={"FolderAddRegular"} color={"#fff"} size={20} />}
                                        appearance="primary"                                        
                                        text={` Create ${labels?.ProjectSingular ?? "Project"}`}
                                        disabled={disabled}
                                      />
                            </NavLink>
                        </React.Fragment>
                    )

                // Create Task button
                case "task":
                    return (
                        disabled ?
                            <OverlayTrigger
                                placement="bottom-end"
                                overlay={
                                    <Tooltip>
                                            You don't have access to create tasks. Please contact administration for assistance.
                                    </Tooltip>
                                }
                            >
                                <div className="project-creation-btn">
                                    <Button className="project-btn" onClick={handleCreateBtnClick} disabled style={{pointerEvents:"none"}}>
                                        Create {labels?.TaskSingular ?? "Task"}
                                    </Button>
                                </div>
                            </OverlayTrigger>
                        :
                            <div className="project-creation-btn">
                                <Button className="project-btn" onClick={handleCreateBtnClick}>Create {labels?.TaskSingular ?? "Task"}</Button>
                            </div>
                    )
                default:
                    return <></>
            }
        }

        return (
            <div className="table-options-container" style={{ padding: "5px 16px 5px 16px" }}>
                <div className="table-options-left">
                    <GroupByDropdown
                        show={showGroupBy}
                        setShow={setShowGroupBy}
                        groupBy={groupBy}
                        groupByFunction={getDataGrouped}
                        pageIdentifier={pageIdentifier}
                    />
                    <SortButton
                        updateSortOrder ={setDataSortOrder}
                        updateSortSelection={setDataSortSelection}
                        clearFilter={clearDataSort}
                        sortData={dataSort}
                        headerText = {sortHeaderText}
                        sortOptionsItems={totalSortOptions}
                    />
                    <FilterButton
                        dateFormatID = {dateFormatID}
                        filterData={itemFilterData}

                        clearFilters = {clearDataFilters}
                        updateFiltersApplied = {updateAppliedDataFilters}
                        updateConjunctionSelection = {updateDataFilterConjunctionSelection}
                        updateTotalFilterOptions={updateDataFilterOptionsTotal}

                        customDropdownToggleSelector={selectCustomDropdownToggle}
                        customDropdownItemSelector={selectCustomDropdownItem}

                        headerText = {setFilterTitle()}

                        pageIdentifier={pageIdentifier}
                    />
                    {children}
                </div>
                <div className="table-options-right">
                    <FluentButton
                        icon={
                            <FluentUiIcon
                                name={"ArrowClockwiseRegular"}
                                color={"#0F6CBD"}
                                size={24}
                            />
                        }
                        onClick={() => refreshTable(false)}
                    />
                    {renderCreateBtn()}
                </div>
            </div>
        )
}

ExpandableFilterRowNew.propTypes = {
    groupBy: PropTypes.string,
    getDataGrouped: PropTypes.func,
    dateFormatID: PropTypes.number,
    nameDropdownData: PropTypes.array,
    memberDropdownData: PropTypes.array,
    tagDropdownData: PropTypes.array,
    updateDataFilterOptionsTotal: PropTypes.func,
    updateAppliedDataFilters: PropTypes.func,
    updateDataFilterConjunctionSelection: PropTypes.func,
    setDataSortSelection: PropTypes.func,
    setDataSortOrder: PropTypes.func,
    disabled: PropTypes.bool,
    clearDataSort: PropTypes.func,
    itemFilterData: PropTypes.object,
    dataSort: PropTypes.object,
    showGroupBy: PropTypes.bool,
    setShowGroupBy: PropTypes.func,
    clearDataFilters: PropTypes.func,
    refreshTable: PropTypes.func,
    handleCreateBtnClick: PropTypes.func,
    totalSortOptions: PropTypes.array,
    sortHeaderText: PropTypes.string,
    children: PropTypes.node,
    pageIdentifier: PropTypes.string,
    privileges: PropTypes.array,
    labels: PropTypes.shape({
        ProjectSingular: PropTypes.string,
        ProjectPlural: PropTypes.string,
        ProjectSingularPossessive: PropTypes.string,
        ProjectPluralPossessive: PropTypes.string,
        TaskSingular: PropTypes.string,
        TaskPlural: PropTypes.string,
        TaskSingularPossessive: PropTypes.string,
        TaskPluralPossessive: PropTypes.string,
        FormSingular: PropTypes.string,
        FormPlural: PropTypes.string,
        FormSingularPossessive: PropTypes.string,
        FormPluralPossessive: PropTypes.string,
    }),
};

export default ExpandableFilterRowNew;
